const MOBILE_MQ = '(max-width: 767px)';
const LABEL_COLLAPSED = 'Read more';
const LABEL_EXPANDED = 'Read less';
const instances = new WeakMap();

export default class PardesnikInspirationBioToggle {
	static init() {
		const cards = document.querySelectorAll('.pardesnik-inspiration__card');
		if (!cards.length) {
			return;
		}

		const mq = window.matchMedia(MOBILE_MQ);

		cards.forEach((card) => {
			const existing = instances.get(card);
			if (existing) {
				existing.applyLayout(mq);
				return;
			}
			const instance = new PardesnikInspirationBioToggle(card);
			instances.set(card, instance);
			instance.setup(mq);
		});

		mq.addEventListener('change', () => {
			cards.forEach((card) => {
				const instance = instances.get(card);
				if (instance) {
					instance.applyLayout(mq);
				}
			});
		});
	}

	constructor(card) {
		this.card = card;
		this.onToggleClick = this.onToggleClick.bind(this);
	}

	setup(mq) {
		this.media = this.card.querySelector('.pardesnik-inspiration__card-media');
		this.info = this.card.querySelector('.pardesnik-inspiration__card-info');
		this.quote = this.card.querySelector('.pardesnik-inspiration__card-quote');
		this.figure = this.card.querySelector('.pardesnik-inspiration__card-image');

		if (!this.quote) {
			return;
		}

		this.reveal = this.ensureReveal();
		this.bio = this.ensureBio();
		this.toggle = this.ensureToggle();

		this.toggle.addEventListener('click', this.onToggleClick);

		this.applyLayout(mq);
	}

	ensureReveal() {
		let reveal = this.card.querySelector('.pardesnik-inspiration__card-reveal');
		if (reveal) {
			return reveal;
		}

		reveal = document.createElement('div');
		reveal.className = 'pardesnik-inspiration__card-reveal';
		reveal.setAttribute('aria-hidden', 'true');

		if (this.info) {
			const infoClone = this.info.cloneNode(true);
			infoClone.querySelectorAll('[data-pardesnik-toggle]').forEach((el) => el.remove());
			reveal.appendChild(infoClone);
		}

		this.card.appendChild(reveal);
		return reveal;
	}

	ensureBio() {
		let bio = this.card.querySelector('.pardesnik-inspiration__card-bio');
		if (bio) {
			return bio;
		}

		bio = document.createElement('div');
		bio.className = 'pardesnik-inspiration__card-bio';

		if (this.info && this.info.parentNode === this.card) {
			this.info.insertAdjacentElement('afterend', bio);
		} else {
			this.card.appendChild(bio);
		}

		return bio;
	}

	ensureToggle() {
		let toggle = this.card.querySelector('[data-pardesnik-toggle]');
		if (toggle) {
			return toggle;
		}

		toggle = document.createElement('button');
		toggle.type = 'button';
		toggle.className = 'pardesnik-inspiration__card-toggle';
		toggle.dataset.pardesnikToggle = '';
		toggle.setAttribute('aria-expanded', 'false');
		toggle.textContent = LABEL_COLLAPSED;
		(this.info || this.card).appendChild(toggle);

		return toggle;
	}

	applyLayout(mq) {
		if (!this.quote) {
			return;
		}

		if (mq.matches) {
			this.card.classList.remove('pardesnik-inspiration__card--has-bio');
			this.card.removeAttribute('tabindex');
			this.card.removeAttribute('role');

			if (this.quote.parentNode !== this.bio) {
				this.bio.appendChild(this.quote);
			}
			return;
		}

		this.collapse();

		this.card.classList.add('pardesnik-inspiration__card--has-bio');
		if (!this.card.hasAttribute('tabindex')) {
			this.card.setAttribute('tabindex', '0');
		}
		if (!this.card.hasAttribute('role')) {
			this.card.setAttribute('role', 'button');
		}

		if (this.quote.parentNode !== this.reveal) {
			this.reveal.appendChild(this.quote);
		}
	}

	collapse() {
		this.card.classList.remove('is-expanded');
		this.toggle.setAttribute('aria-expanded', 'false');
		this.toggle.textContent = LABEL_COLLAPSED;
		this.bio.style.maxHeight = '';
	}

	toggleExpanded() {
		const expanded = this.card.classList.toggle('is-expanded');
		this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		this.toggle.textContent = expanded ? LABEL_EXPANDED : LABEL_COLLAPSED;

		if (window.matchMedia(MOBILE_MQ).matches) {
			this.animateBio(expanded);
		}
	}

	animateBio(expanded) {
		this.bio.style.maxHeight = `${this.bio.scrollHeight}px`;

		if (!expanded) {
			void this.bio.offsetHeight;
			this.bio.style.maxHeight = '0px';
		}
	}

	onToggleClick(event) {
		event.preventDefault();
		event.stopPropagation();
		this.toggleExpanded();
	}
}